﻿export interface ICenterContractSummary {
    id: number,
    alias: string,
    name: string,
    isMemberCenter: boolean,
    contracts: any[]
}